import React from 'react';
import { Card, Text, Skeleton } from '@mantine/core';
import UnifiedEChartsV2 from './UnifiedEChartsV2';
import type { SeriesPoint } from './UnifiedEChartsV2';

export type OverlayShapes = Record<string, 'line' | 'step' | 'bar' | 'boxplot' | 'arearange'>;
export type UnitAxisSides = Record<string, 'left' | 'right'>;

type Props = {
  mode?: 'line' | 'arearange' | 'candlestick' | 'bar' | 'boxplot';
  data: SeriesPoint[];
  metrics: string[];
  colors: Record<string, string>;
  axes?: Record<string, 'left' | 'right' | 'both'>;
  shapes?: Record<string, 'line' | 'step' | 'bar' | 'boxplot' | 'arearange'>;
  units?: Record<string, string>;
  resolution?: string;
  dateOnlyTicks?: boolean;
  height?: number;
  showLegend?: boolean;
  displayNameMap?: Record<string, string>;
  overlayLines?: { metrics: string[]; colors?: Record<string, string>; shapes?: OverlayShapes };
  unitAxisSides?: UnitAxisSides;
  showTrends?: boolean;
  trendTargets?: 'all' | 'overlay' | 'base';
  // loading state
  loading?: boolean;
};

const DataChartSection: React.FC<Props> = ({ loading = false, ...props }) => {
  // Show skeleton loader when loading
  if (loading) {
    return (
      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Text fw={500} mb="md">Chart Loading...</Text>
        <Skeleton height={props.height || 400} />
      </Card>
    );
  }
  
  return <UnifiedEChartsV2 {...props} />;
};

export default DataChartSection;
